import { ref } from 'vue'
import { useFormStore } from '../stores/formStore'

export function useFormSubmission() {
  const formStore = useFormStore()
  const isSubmitting = ref(false)
  const submitError = ref(null)
  const submitSuccess = ref(false)

  const submitForm = async () => {
    if (isSubmitting.value) return

    isSubmitting.value = true
    submitError.value = null
    submitSuccess.value = false

    try {
      // Get sanitized form data from the store
      const submissionData = formStore.submissionData

      // Submit to the server using the same endpoint and format as the old AJAX
      const response = await fetch('/membership-application-submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify(submissionData),
      })

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }

      const result = await response.json()
      console.log('Full server response:', JSON.stringify(result, null, 2))

      if (result.success === true) {
        submitSuccess.value = true
        // Redirect to confirmation page like the old implementation
        window.location.href = '/membership-application/confirmation'
        console.log(result.responseText)

        return {
          success: true,
          data: result,
        }
      }

      // Handle server-side validation errors
      console.log(result.success)
      console.log(result.responseText)
      throw new Error(
        'There was an unexpected issue submitting your application. Please try again in a few minutes.',
      )
    } catch (error) {
      console.error('Form submission error:', error)

      let errorMessage =
        'There was an unexpected issue submitting your application. Please try again in a few minutes.'

      // Include status information like the old implementation
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        errorMessage += ` Network error: ${error.message}`
      }
      if (error.message.includes('HTTP')) {
        errorMessage += ` ${error.message}`
      }

      submitError.value = errorMessage

      return {
        success: false,
        error: errorMessage,
      }
    } finally {
      isSubmitting.value = false
    }
  }

  const resetSubmissionState = () => {
    submitError.value = null
    submitSuccess.value = false
    isSubmitting.value = false
  }

  return {
    submitForm,
    isSubmitting,
    submitError,
    submitSuccess,
    resetSubmissionState,
  }
}
